// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__1krzR","title":"AfterImages45_title__XvzRO","images":"AfterImages45_images__2nWSa"};